import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-stock-corr-code',
  templateUrl: './stock-corr-code.component.html',
  styleUrls: ['./stock-corr-code.component.css']
})
export class StockCorrCodeComponent implements OnInit {
    stockCorrCodeKeyno;

    public edit?: Edit;

    public saving = false;

    public stockCorrCodeNameButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'stockcorrcodelangs', gotoParms: () => this.edit!.stockcorrcode_keyno ?? '' }
    ];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.stockCorrCodeKeyno = this.stateService.getStateParams()['stockcorrcode_keyno'];
    }

    private async loadEdit() {
        if (!!this.stockCorrCodeKeyno) {
            this.edit = (await this.datatask.Post(2483, { stockcorrcode_keyno: this.stockCorrCodeKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2484, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    stockcorrcode_keyno: string;
    stockcorrcode_name: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockCorrCode', {
//        templateUrl: 'views/components/views/stockCorrCode/stockCorrCode.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'stockCorrCodeService', function ($stateParams, stateService, translateService, modalService, stockCorrCodeService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockCorrCodeKeyno = $stateParams.stockcorrcode_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                stockCorrCodeNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('stockcorrcodelangs', { stockcorrcode_keyno: vm.model.edit.stockcorrcode_keyno }) }
//                ],
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            translateService.translateBatch(translations).then(function (data) {
//                angular.forEach(translations, function (_, key) {
//                    if (angular.isDefined(data[key])) {
//                        translations[key] = data[key];
//                    }
//                });
//            });

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            let loadEdit = function () {
//                stockCorrCodeService.getStockCorrectionCode({ stockcorrcode_keyno: stockCorrCodeKeyno }).then(function (info) {
//                    angular.copy(info[0], vm.model.edit);
//                });
//            };

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                stockCorrCodeService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
